// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ServicePlansInformation-servicePlansInfoContainer-h2gKu {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
        -ms-flex-direction: column;
            flex-direction: column;
    gap: 24px;
}

.ServicePlansInformation-servicePlansInfoBox-FsqOZ {
    background: var(--secondary-gray-bg);
}

.ServicePlansInformation-servicePlansTipMessageBox-CeAjs,
.ServicePlansInformation-servicePlansInfoBox-FsqOZ {
    padding: 24px;
    border: 1px solid var(--primary-border);
    border-radius: 12px;
}

.ServicePlansInformation-servicePlansInfoTitleBox-C4imi {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
        -ms-flex-align: center;
            align-items: center;
    -webkit-box-pack: justify;
        -ms-flex-pack: justify;
            justify-content: space-between;
    gap: 18px;
}

.ServicePlansInformation-servicePlansInfoImgBox-rqEFG {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
        -ms-flex-align: center;
            align-items: center;
    gap: 8px;
    font-size: 20px;
    line-height: 26px;
    font-weight: 500;
    color: var(--primary-foreground);
}

.ServicePlansInformation-servicePlansInfoImgWrapper-tzuvt {
    position: relative;
    width: 32px;
    height: 32px;
    border-radius: 4px;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
        -ms-flex-align: center;
            align-items: center;
    -webkit-box-pack: center;
        -ms-flex-pack: center;
            justify-content: center;
    background: var(--tertiary-gray-bg);
    -ms-flex-negative: 0;
        flex-shrink: 0;
}

.ServicePlansInformation-servicePlansInfoImg-MKv3G {
    position: absolute;
    top: 50%;
    left: 50%;
    width: 16px;
    height: 16px;
    -webkit-transform: translate(-50%, -50%);
        -ms-transform: translate(-50%, -50%);
            transform: translate(-50%, -50%);
}

.ServicePlansInformation-servicePlansInfoBadge-QZsYQ,
.ServicePlansInformation-servicePlansPricingDesc-N_viZ,
.ServicePlansInformation-servicePlansBenefitsFeature-rGgyY {
    font-size: 14px;
    line-height: 20px;
}

.ServicePlansInformation-servicePlansInfoBadge-QZsYQ {
    border: 1px solid var(--primary-border);
    padding: 4px 12px;
    background: var(--servicePlan-badge-bg);
    color: var(--quaternary-foreground);
    border-radius: 100px;
    font-weight: 500;
    -ms-flex-negative: 0;
        flex-shrink: 0;
}

.ServicePlansInformation-servicePlansPricingBox-gjmHt,
.ServicePlansInformation-servicePlansPricingInnerWrapper-hbqbK,
.ServicePlansInformation-servicePlansBenefitsBox-uhlxX {
    margin-top: 18px;
    border-top: 1px solid var(--primary-border);
    padding-top: 18px;
}

.ServicePlansInformation-servicePlansPricingTitleBox-A_WGn {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
        -ms-flex-align: center;
            align-items: center;
    gap: 4px;
    font-size: 24px;
    line-height: 30px;
    font-weight: 600;
    color: var(--primary-foreground);
    margin-bottom: 6px;
}

.ServicePlansInformation-servicePlansPricingSecondaryTitle-ThZO1,
.ServicePlansInformation-servicePlansPricingAmountBox-T8Ccw,
.ServicePlansInformation-servicePlansTipMessageBox-CeAjs,
.ServicePlansInformation-servicePlansBenefitsTitleText-Przy1 {
    font-size: 16px;
    line-height: 22px;
    font-weight: 400;
}

.ServicePlansInformation-servicePlansPricingSecondaryTitle-ThZO1 {
    color: var(--tertiary-foreground);
}

.ServicePlansInformation-servicePlansPricingDesc-N_viZ {
    font-weight: 400;
    color: var(--primary-foreground);
}

.ServicePlansInformation-servicePlansPricingTitleWrapper-PRIoj {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
        -ms-flex-align: center;
            align-items: center;
    -ms-flex-wrap: wrap;
        flex-wrap: wrap;
}

.ServicePlansInformation-servicePlansPricingInnerWrapper-hbqbK {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
        -ms-flex-direction: column;
            flex-direction: column;
    gap: 12px;
}

.ServicePlansInformation-servicePlansPricingAmountBox-T8Ccw {
    display: grid;
    grid-template-columns: 3fr 2fr;
    gap: 4px;
    color: var(--primary-foreground);
}

.ServicePlansInformation-servicePlansPricingAmountTitle-gYpao {
    text-align: start;
}

.ServicePlansInformation-servicePlansPricingAmount-tXV_s {
    text-align: end;
}

.ServicePlansInformation-servicePlansTipSpecialText-W3Tzb {
    font-weight: 600;
}

.ServicePlansInformation-servicePlansBenefitsBox-uhlxX {
    display: grid;
    gap: 12px;
}

.ServicePlansInformation-servicePlansBenefitsTitle-VEfbk,
.ServicePlansInformation-servicePlansBenefitsFeature-rGgyY {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
        -ms-flex-align: center;
            align-items: center;
    gap: 4px;
}

.ServicePlansInformation-servicePlansBenefitsTitleText-Przy1 {
    font-weight: 500;
    color: var(--primary-foreground);
}

.ServicePlansInformation-servicePlansBenefitsFeature-rGgyY {
    font-weight: 400;
    color: var(--primary-foreground);
}

.ServicePlansInformation-servicePlansBenefitsFeature-rGgyY svg {
    -ms-flex-negative: 0;
        flex-shrink: 0;
}`, "",{"version":3,"sources":["webpack://./src/components/ServicePlanContainer/ServicePlansPayment/ServicePlansInformation.css"],"names":[],"mappings":"AAAA;IACI,oBAAa;IAAb,oBAAa;IAAb,aAAa;IACb,4BAAsB;IAAtB,6BAAsB;QAAtB,0BAAsB;YAAtB,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,oCAAoC;AACxC;;AAEA;;IAEI,aAAa;IACb,uCAAuC;IACvC,mBAAmB;AACvB;;AAEA;IACI,oBAAa;IAAb,oBAAa;IAAb,aAAa;IACb,yBAAmB;QAAnB,sBAAmB;YAAnB,mBAAmB;IACnB,yBAA8B;QAA9B,sBAA8B;YAA9B,8BAA8B;IAC9B,SAAS;AACb;;AAEA;IACI,oBAAa;IAAb,oBAAa;IAAb,aAAa;IACb,yBAAmB;QAAnB,sBAAmB;YAAnB,mBAAmB;IACnB,QAAQ;IACR,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,gCAAgC;AACpC;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,oBAAa;IAAb,oBAAa;IAAb,aAAa;IACb,yBAAmB;QAAnB,sBAAmB;YAAnB,mBAAmB;IACnB,wBAAuB;QAAvB,qBAAuB;YAAvB,uBAAuB;IACvB,mCAAmC;IACnC,oBAAc;QAAd,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,WAAW;IACX,YAAY;IACZ,wCAAgC;QAAhC,oCAAgC;YAAhC,gCAAgC;AACpC;;AAEA;;;IAGI,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,uCAAuC;IACvC,iBAAiB;IACjB,uCAAuC;IACvC,mCAAmC;IACnC,oBAAoB;IACpB,gBAAgB;IAChB,oBAAc;QAAd,cAAc;AAClB;;AAEA;;;IAGI,gBAAgB;IAChB,2CAA2C;IAC3C,iBAAiB;AACrB;;AAEA;IACI,oBAAa;IAAb,oBAAa;IAAb,aAAa;IACb,yBAAmB;QAAnB,sBAAmB;YAAnB,mBAAmB;IACnB,QAAQ;IACR,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,gCAAgC;IAChC,kBAAkB;AACtB;;AAEA;;;;IAII,eAAe;IACf,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,gBAAgB;IAChB,gCAAgC;AACpC;;AAEA;IACI,oBAAa;IAAb,oBAAa;IAAb,aAAa;IACb,yBAAmB;QAAnB,sBAAmB;YAAnB,mBAAmB;IACnB,mBAAe;QAAf,eAAe;AACnB;;AAEA;IACI,oBAAa;IAAb,oBAAa;IAAb,aAAa;IACb,4BAAsB;IAAtB,6BAAsB;QAAtB,0BAAsB;YAAtB,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,QAAQ;IACR,gCAAgC;AACpC;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,SAAS;AACb;;AAEA;;IAEI,oBAAa;IAAb,oBAAa;IAAb,aAAa;IACb,yBAAmB;QAAnB,sBAAmB;YAAnB,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,gBAAgB;IAChB,gCAAgC;AACpC;;AAEA;IACI,gBAAgB;IAChB,gCAAgC;AACpC;;AAEA;IACI,oBAAc;QAAd,cAAc;AAClB","sourcesContent":[".servicePlansInfoContainer {\n    display: flex;\n    flex-direction: column;\n    gap: 24px;\n}\n\n.servicePlansInfoBox {\n    background: var(--secondary-gray-bg);\n}\n\n.servicePlansTipMessageBox,\n.servicePlansInfoBox {\n    padding: 24px;\n    border: 1px solid var(--primary-border);\n    border-radius: 12px;\n}\n\n.servicePlansInfoTitleBox {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 18px;\n}\n\n.servicePlansInfoImgBox {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    font-size: 20px;\n    line-height: 26px;\n    font-weight: 500;\n    color: var(--primary-foreground);\n}\n\n.servicePlansInfoImgWrapper {\n    position: relative;\n    width: 32px;\n    height: 32px;\n    border-radius: 4px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    background: var(--tertiary-gray-bg);\n    flex-shrink: 0;\n}\n\n.servicePlansInfoImg {\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    width: 16px;\n    height: 16px;\n    transform: translate(-50%, -50%);\n}\n\n.servicePlansInfoBadge,\n.servicePlansPricingDesc,\n.servicePlansBenefitsFeature {\n    font-size: 14px;\n    line-height: 20px;\n}\n\n.servicePlansInfoBadge {\n    border: 1px solid var(--primary-border);\n    padding: 4px 12px;\n    background: var(--servicePlan-badge-bg);\n    color: var(--quaternary-foreground);\n    border-radius: 100px;\n    font-weight: 500;\n    flex-shrink: 0;\n}\n\n.servicePlansPricingBox,\n.servicePlansPricingInnerWrapper,\n.servicePlansBenefitsBox {\n    margin-top: 18px;\n    border-top: 1px solid var(--primary-border);\n    padding-top: 18px;\n}\n\n.servicePlansPricingTitleBox {\n    display: flex;\n    align-items: center;\n    gap: 4px;\n    font-size: 24px;\n    line-height: 30px;\n    font-weight: 600;\n    color: var(--primary-foreground);\n    margin-bottom: 6px;\n}\n\n.servicePlansPricingSecondaryTitle,\n.servicePlansPricingAmountBox,\n.servicePlansTipMessageBox,\n.servicePlansBenefitsTitleText {\n    font-size: 16px;\n    line-height: 22px;\n    font-weight: 400;\n}\n\n.servicePlansPricingSecondaryTitle {\n    color: var(--tertiary-foreground);\n}\n\n.servicePlansPricingDesc {\n    font-weight: 400;\n    color: var(--primary-foreground);\n}\n\n.servicePlansPricingTitleWrapper {\n    display: flex;\n    align-items: center;\n    flex-wrap: wrap;\n}\n\n.servicePlansPricingInnerWrapper {\n    display: flex;\n    flex-direction: column;\n    gap: 12px;\n}\n\n.servicePlansPricingAmountBox {\n    display: grid;\n    grid-template-columns: 3fr 2fr;\n    gap: 4px;\n    color: var(--primary-foreground);\n}\n\n.servicePlansPricingAmountTitle {\n    text-align: start;\n}\n\n.servicePlansPricingAmount {\n    text-align: end;\n}\n\n.servicePlansTipSpecialText {\n    font-weight: 600;\n}\n\n.servicePlansBenefitsBox {\n    display: grid;\n    gap: 12px;\n}\n\n.servicePlansBenefitsTitle,\n.servicePlansBenefitsFeature {\n    display: flex;\n    align-items: center;\n    gap: 4px;\n}\n\n.servicePlansBenefitsTitleText {\n    font-weight: 500;\n    color: var(--primary-foreground);\n}\n\n.servicePlansBenefitsFeature {\n    font-weight: 400;\n    color: var(--primary-foreground);\n}\n\n.servicePlansBenefitsFeature svg {\n    flex-shrink: 0;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"servicePlansInfoContainer": `ServicePlansInformation-servicePlansInfoContainer-h2gKu`,
	"servicePlansInfoBox": `ServicePlansInformation-servicePlansInfoBox-FsqOZ`,
	"servicePlansTipMessageBox": `ServicePlansInformation-servicePlansTipMessageBox-CeAjs`,
	"servicePlansInfoTitleBox": `ServicePlansInformation-servicePlansInfoTitleBox-C4imi`,
	"servicePlansInfoImgBox": `ServicePlansInformation-servicePlansInfoImgBox-rqEFG`,
	"servicePlansInfoImgWrapper": `ServicePlansInformation-servicePlansInfoImgWrapper-tzuvt`,
	"servicePlansInfoImg": `ServicePlansInformation-servicePlansInfoImg-MKv3G`,
	"servicePlansInfoBadge": `ServicePlansInformation-servicePlansInfoBadge-QZsYQ`,
	"servicePlansPricingDesc": `ServicePlansInformation-servicePlansPricingDesc-N_viZ`,
	"servicePlansBenefitsFeature": `ServicePlansInformation-servicePlansBenefitsFeature-rGgyY`,
	"servicePlansPricingBox": `ServicePlansInformation-servicePlansPricingBox-gjmHt`,
	"servicePlansPricingInnerWrapper": `ServicePlansInformation-servicePlansPricingInnerWrapper-hbqbK`,
	"servicePlansBenefitsBox": `ServicePlansInformation-servicePlansBenefitsBox-uhlxX`,
	"servicePlansPricingTitleBox": `ServicePlansInformation-servicePlansPricingTitleBox-A_WGn`,
	"servicePlansPricingSecondaryTitle": `ServicePlansInformation-servicePlansPricingSecondaryTitle-ThZO1`,
	"servicePlansPricingAmountBox": `ServicePlansInformation-servicePlansPricingAmountBox-T8Ccw`,
	"servicePlansBenefitsTitleText": `ServicePlansInformation-servicePlansBenefitsTitleText-Przy1`,
	"servicePlansPricingTitleWrapper": `ServicePlansInformation-servicePlansPricingTitleWrapper-PRIoj`,
	"servicePlansPricingAmountTitle": `ServicePlansInformation-servicePlansPricingAmountTitle-gYpao`,
	"servicePlansPricingAmount": `ServicePlansInformation-servicePlansPricingAmount-tXV_s`,
	"servicePlansTipSpecialText": `ServicePlansInformation-servicePlansTipSpecialText-W3Tzb`,
	"servicePlansBenefitsTitle": `ServicePlansInformation-servicePlansBenefitsTitle-VEfbk`
};
module.exports = ___CSS_LOADER_EXPORT___;
